import { useState, useEffect, useMemo, useCallback } from "react";
import Cookies from "js-cookie";

// Cookie 键名常量
const COOKIE_KEYS = {
  FILTER_STATUS: "botcontrol_filter_status",
  FILTER_SERVER: "botcontrol_filter_server",
};

// 状态标签颜色映射
export const STATUS_COLOR_MAP = {
  在线: "green",
  离线: "gray",
  启动中: "blue",
  错误: "red",
};

// 状态优先级映射（用于排序）
const STATUS_PRIORITY = {
  启动中: 1,
  在线: 2,
  离线: 3,
  错误: 4,
};

/**
 * 管理 BotControl 的筛选、搜索、排序逻辑及 Cookie 持久化
 * @param {Array} bots - 原始假人列表
 */
export function useBotFilters(bots) {
  const [filterStatus, setFilterStatus] = useState(() => {
    return Cookies.get(COOKIE_KEYS.FILTER_STATUS) || "all";
  });

  const [filterServer, setFilterServer] = useState(() => {
    return Cookies.get(COOKIE_KEYS.FILTER_SERVER) || "all";
  });

  const [searchText, setSearchText] = useState("");

  // 保存筛选状态到 cookie
  useEffect(() => {
    Cookies.set(COOKIE_KEYS.FILTER_STATUS, filterStatus, { expires: 7 });
  }, [filterStatus]);

  useEffect(() => {
    Cookies.set(COOKIE_KEYS.FILTER_SERVER, filterServer, { expires: 7 });
  }, [filterServer]);

  // 获取唯一的服务器列表
  const serverList = useMemo(() => {
    return [
      "all",
      ...new Set(bots.map((bot) => `${bot.host}:${bot.port}`)),
    ];
  }, [bots]);

  // 过滤和排序后的假人列表
  const filteredBots = useMemo(() => {
    const filtered = bots.filter((bot) => {
      const matchesSearch =
        searchText === "" ||
        bot.name.toLowerCase().includes(searchText.toLowerCase()) ||
        bot.id.toLowerCase().includes(searchText.toLowerCase());

      const matchesStatus =
        filterStatus === "all" || bot.status === filterStatus;

      const matchesServer =
        filterServer === "all" ||
        `${bot.host}:${bot.port}` === filterServer;

      return matchesSearch && matchesStatus && matchesServer;
    });

    return [...filtered].sort((a, b) => {
      return STATUS_PRIORITY[a.status] - STATUS_PRIORITY[b.status];
    });
  }, [bots, searchText, filterStatus, filterServer]);

  const resetFilters = useCallback(() => {
    setFilterStatus("all");
    setFilterServer("all");
    setSearchText("");
  }, []);

  return {
    filterStatus,
    setFilterStatus,
    filterServer,
    setFilterServer,
    searchText,
    setSearchText,
    serverList,
    filteredBots,
    resetFilters,
  };
}
